<script>
let Constants = {
    //  install
    install(Vue, options) {
        //  create global Constants
        Vue.Constants = {
            AREA_TYPES: [
                'kitchen',
                'living_room',
                'kitchen_w_living_room',
                'bedroom',
                'children_room',
                'bathroom',
                'toilet',
                'hallway',
                'gallery',
                'dressing_room',
                'other'
            ],
            AREA_FLAT_TYPES: [
                'flat_technical_room'
            ],
            AREA_HOUSE_TYPES: [
                'technical_room',
                'workshop',
                'uninhabited_attic'
            ],
            IGNORED_TYPES: [
                'workshop',
                'uninhabited_attic'
            ]
        };
    }
};

export default Constants;
</script>
